<div class="panel panel-plan min-height">

	<div class="row">
		<div class="col-12">
			<div class="stepper pe-0">
				<div class="stepper-icon" [class.bg-success]="planFormSrv.isDataValid">
					<i class="material-icons" [class.d-block]="planFormSrv.isDataValid">done</i>
				</div>
				<div data-testid="SUBSYS2_PLANFORM_DATA_TITLE_TXT" class="stepper-label">
					{{ labels().PLAN_FORM_COMPONENT_FORM_TITLE }}
				</div>
			</div>
		</div>
	</div>

	@if (form) {
	<form class="px-4" [formGroup]="form">
		<div class="row mt-5">

			<div class="col-5">
				<div class="form-group pe-5">
					<label data-testid="SUBSYS2_PLANFORM_PLANID_LBL" for="PlanId">
						{{ labels().PLAN_FORM_COMPONENT_PLAN_ID }} &nbsp; *
					</label>
					<input data-testid="SUBSYS2_PLANFORM_PLANID_INPUT" type="text" class="form-control" id="PlanId"
						[placeholder]="labels().PLAN_FORM_COMPONENT_PLAN_ID" formControlName="planId" (change)="trimPlanId()"
						[class]="{'is-valid': formCtrl!.planId.valid && formCtrl!.planId.touched, 'is-invalid': formCtrl!.planId.invalid && formCtrl!.planId.touched}"
						[appFormValidationMsg]="errorMsgs.planId" [readonly]="isReadonly ? true : null" />
				</div>
			</div>

			<div class="col-7">
				<div class="form-group">
					<label data-testid="SUBSYS2_PLANFORM_NOTES_LBL" for="Notes">
						{{ labels().PLAN_FORM_COMPONENT_NOTES }}
					</label>
					<input data-testid="SUBSYS2_PLANFORM_NOTES_INPUT" type="text" class="form-control" id="Notes"
						[placeholder]="labels().PLAN_FORM_COMPONENT_NOTES" formControlName="notes"
						[class]="{'is-valid': formCtrl!.notes.valid && formCtrl!.notes.touched, 'is-invalid': formCtrl!.notes.invalid && formCtrl!.notes.touched}"
						[appFormValidationMsg]="errorMsgs.notes" [readonly]="isReadonly ? true : null" />
				</div>
			</div>

		</div>

		@if (hasProducts()) {
		<hr>

		<div class="d-flex align-items-center py-4">
			<span data-testid="SUBSYS2_PLANFORM_DEVICE_TXT">{{ labels().PLAN_FORM_COMPONENT_DEVICE_MSG }} &nbsp; *</span>
			<div class="btn-group ms-5" aria-label="Device button group">
				@if (isTlhex()) {
				<input type="radio" class="btn-check" name="device" id="device1" autocomplete="off" formControlName="device"
					[value]="deviceEnum.Tlhex" (change)="update()" [attr.disabled]="isCheckUp || isReadonly ? true : null"
					[class]="{'is-invalid': formCtrl!.device.invalid && formCtrl!.device.touched}">
				<label data-testid="SUBSYS2_PLANFORM_DEVICE_TLHEX_BTN" class="btn btn-outline py-2 m-0" for="device1">
					{{ deviceEnum.Tlhex | deviceLabel | uppercase }}
				</label>
				}
				@if (isFitbone()) {
				<input type="radio" class="btn-check" name="device" id="device2" autocomplete="off" formControlName="device"
					[value]="deviceEnum.Fitbone" (change)="update()" [attr.disabled]="isCheckUp || isReadonly ? true : null"
					[class]="{'is-invalid': formCtrl!.device.invalid && formCtrl!.device.touched}">
				<label data-testid="SUBSYS2_PLANFORM_DEVICE_FITBONE_BTN" class="btn btn-outline py-2 m-0" for="device2">
					{{ deviceEnum.Fitbone | deviceLabel | uppercase }}
				</label>
				}
				@if (isJps()) {
				<input type="radio" class="btn-check" name="device" id="device3" autocomplete="off" formControlName="device"
					[value]="deviceEnum.Jps" (change)="update()" [attr.disabled]="isCheckUp || isReadonly ? true : null"
					[class]="{'is-invalid': formCtrl!.device.invalid && formCtrl!.device.touched}">
				<label data-testid="SUBSYS2_PLANFORM_DEVICE_JPS_BTN" class="btn btn-outline py-2 m-0" for="device3">
					{{ deviceEnum.Jps | deviceLabel | uppercase }}
				</label>
				}
			</div>
			@if (formCtrl!.device.invalid && formCtrl!.device.touched) {
			<div class="invalid-feedback d-block ms-4">
				{{ formCtrl!.device | validationMsg:errorMsgs.device | async }}
			</div>
			}
		</div>

		<hr>

		<div data-testid="SUBSYS2_PLANFORM_TLHEXDATA_BOX" class="row mt-5"
			[ngbCollapse]="formValue.device != deviceEnum.Tlhex">
			<div class="col-4">
				<div class="form-group">
					<label data-testid="SUBSYS2_PLANFORM_PLANSCENARIO_LBL" for="postOperative">
						{{ labels().PLAN_FORM_COMPONENT_SCENARIO }} &nbsp; *
					</label>
					<div class="custom-control custom-radio custom-control-inline">
						<input data-testid="SUBSYS2_PLANFORM_PREOP_RADIO" type="radio" id="stepPreop" name="postOperative"
							[value]="false" [attr.disabled]="isCheckUp || isReadonly ? true : null" class="custom-control-input"
							formControlName="postOperative"
							[class]="{'is-valid': formCtrl!.postOperative.valid && formCtrl!.postOperative.touched, 'is-invalid': formCtrl!.postOperative.invalid && formCtrl!.postOperative.touched}" />
						<label class="custom-control-label" for="stepPropp">
							{{ labels().PLAN_FORM_COMPONENT_SCENARIO_PREOPERATIVE }}
						</label>
					</div>
					<div class="custom-control custom-radio custom-control-inline">
						<input data-testid="SUBSYS2_PLANFORM_POSTOP_RADIO" type="radio" id="stepPostop" name="postOperative"
							[value]="true" [attr.disabled]="isCheckUp || isReadonly ? true : null" class="custom-control-input"
							formControlName="postOperative"
							[class]="{'is-valid': formCtrl!.postOperative.valid && formCtrl!.postOperative.touched, 'is-invalid': formCtrl!.postOperative.invalid && formCtrl!.postOperative.touched}" />
						<label class="custom-control-label" for="stepPostop">
							{{ labels().PLAN_FORM_COMPONENT_SCENARIO_POSTOPERATIVE }}
						</label>
					</div>
					@if (formCtrl!.postOperative.invalid && formCtrl!.planType.touched) {
					<div class="invalid-feedback d-block">
						{{ formCtrl!.postOperative | validationMsg:errorMsgs.postOperative | async }}
					</div>
					}
				</div>
			</div>
			<div class="col-4">
				<div class="form-group">
					<label data-testid="SUBSYS2_PLANFORM_PLANTYPE_LBL" for="planType">
						{{ labels().PLAN_FORM_COMPONENT_PLAN_TYPE }} &nbsp; *
					</label>
					<div class="custom-control custom-radio custom-control-inline">
						<input data-testid="SUBSYS2_PLANFORM_DEFORMITY_RADIO" type="radio" id="planType_DEF" name="planType"
							[value]="planTypeEnum.Deformity" [attr.disabled]="isCheckUp || isReadonly ? true : null"
							class="custom-control-input" formControlName="planType"
							[class]="{'is-valid': formCtrl!.planType.valid && formCtrl!.planType.touched, 'is-invalid': formCtrl!.planType.invalid && formCtrl!.planType.touched}" />
						<label class="custom-control-label" for="planType_DEF">
							{{ labels().PLAN_FORM_COMPONENT_TYPE_DEFORMITY }}
						</label>
					</div>
					<div class="custom-control custom-radio custom-control-inline">
						<input data-testid="SUBSYS2_PLANFORM_FRACTURE_RADIO" type="radio" id="planType_FRA" name="planType"
							[value]="planTypeEnum.Fracture" [attr.disabled]="isCheckUp || isReadonly ? true : null"
							class="custom-control-input" formControlName="planType"
							[class]="{'is-valid': formCtrl!.planType.valid && formCtrl!.planType.touched, 'is-invalid': formCtrl!.planType.invalid && formCtrl!.planType.touched}" />
						<label class="custom-control-label" for="planType_FRA">
							{{ labels().PLAN_FORM_COMPONENT_TYPE_FRACTURE }}
						</label>
					</div>
					@if (formCtrl!.planType.invalid && formCtrl!.planType.touched) {
					<div class="invalid-feedback d-block">
						{{ formCtrl!.planType | validationMsg:errorMsgs.planType | async }}
					</div>
					}
				</div>
			</div>
			<div class="col-4">
				<div class="form-group">
					<label data-testid="SUBSYS2_PLANFORM_REFERENCETYPE_LBL" for="referenceType">
						{{ labels().PLAN_FORM_COMPONENT_REFERENCE_TYPE }} &nbsp; *</label>
					<div class="custom-control custom-radio custom-control-inline">
						<input data-testid="SUBSYS2_PLANFORM_PROXIMAL_RADIO" type="radio" id="referenceType_PROX"
							name="referenceType" [value]="referenceTypeEnum.Proximal"
							[attr.disabled]="isCheckUp || isReadonly ? true : null" class="custom-control-input"
							formControlName="referenceType"
							[class]="{'is-valid': formCtrl!.referenceType.valid && formCtrl!.referenceType.touched, 'is-invalid': formCtrl!.referenceType.invalid && formCtrl!.referenceType.touched}" />
						<label class="custom-control-label" for="referenceType_PROX">
							{{ labels().PLAN_FORM_COMPONENT_REFERENCE_PROXIMAL }}
						</label>
					</div>
					<div class="custom-control custom-radio custom-control-inline">
						<input data-testid="SUBSYS2_PLANFORM_DISTAL_RADIO" type="radio" id="referenceType_DIST" name="referenceType"
							[value]="referenceTypeEnum.Distal" [attr.disabled]="isCheckUp || isReadonly ? true : null"
							class="custom-control-input" formControlName="referenceType"
							[class]="{'is-valid': formCtrl!.referenceType.valid && formCtrl!.referenceType.touched, 'is-invalid': formCtrl!.referenceType.invalid && formCtrl!.referenceType.touched}" />
						<label class="custom-control-label" for="referenceType_DIST">
							{{ labels().PLAN_FORM_COMPONENT_REFERENCE_DISTAL }}
						</label>
					</div>
					@if (formCtrl!.referenceType.invalid && formCtrl!.referenceType.touched) {
					<div class="invalid-feedback d-block">
						{{ formCtrl!.referenceType | validationMsg:errorMsgs.referenceType | async }}
					</div>
					}
				</div>
			</div>
		</div>
		}

	</form>
	}


</div>